import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import {
  type AddressMapPopoverDataProps,
  addressMapPopoverDataSchema,
} from "./AddressMapPopover.schema";
import { AddressMapPopover } from "./components/AddressMapPopover";
import type { RouteSummary } from "./types";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "address-map-popover": {
      props: AddressMapPopoverDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-address-map-popover": HTMLElement;
  }
}

export function RWCAddressMapPopover({
  addressId,
  title,
  routeFrom,
  mode,
  side,
}: AddressMapPopoverDataProps): JSX.Element {
  const host = useIslandHost();

  const handleRoute = (route: RouteSummary) => {
    host?.dispatchEvent(
      new CustomEvent("address-map:route", {
        detail: { route },
        bubbles: true,
      }),
    );
  };

  return (
    <AddressMapPopover
      addressId={addressId}
      title={title}
      routeFrom={routeFrom}
      mode={mode}
      side={side}
      onRoute={handleRoute}
    />
  );
}

componentManager.register(
  rwc("address-map-popover", {
    component: RWCAddressMapPopover,
    dataSchema: addressMapPopoverDataSchema,
  }),
);
